export function extractNumericValue(str) {
  // Remove all non-digit characters except dots and commas
  let cleaned = str?.replace(/[^\d.,]/g, "");

  // Remove commas (thousand separators)
  cleaned = cleaned?.replace(/,/g, "");

  // Convert to number
  return parseFloat(cleaned);
}
